import type { ExperimentalMutations } from '../__types__/ExperimentalMutations';
import { fetchJSON } from '../fetchJSON';
import { MediaType } from '../MediaType';
import type { ResolverContext } from '../resolver-context';

export const experimentalDisableKeyboardShortcuts: ExperimentalMutations['experimentalDisableKeyboardShortcuts'] =
	(_, {}, context) => setKeyboardShortcutsEnabled(context, false);

export const experimentalEnableKeyboardShortcuts: ExperimentalMutations['experimentalEnableKeyboardShortcuts'] =
	(_, {}, context) => setKeyboardShortcutsEnabled(context, true);

const setKeyboardShortcutsEnabled = ({ network }: ResolverContext, enabled: boolean) =>
	fetchJSON(network, '/wiki/rest/confluenceshortcuts/latest/enabled', {
		method: 'POST',
		headers: {
			'Content-Type': MediaType.JSON,
		},
		body: JSON.stringify({ enabled }),
	}).then(
		(data) => ({ enabled: data }),
		() => ({ enabled: false }),
	);
